//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["dataConfig","tabPage"],
  data() {
    return {
      list: [],
      isLoading: false,
      isFinished: false,

      isFirst: false,

      Page: {
        PageSize: 10,
        PageIndex: 1,
        PageCount: 0
      }
    };
  },

  created(){

    console.log("dataConfig",this.dataConfig);

  },
  mounted() {},
  methods: {

    $getSubmitData(){      
      var formData = this.$parent.$getSubmitData();
      return formData;
    },

    $getActionObj(){
      console.log(this.$parent,'$parent');
      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },

    onClickItem(dataItem, index) {
      console.log("onClickItem", dataItem);
      if(!dataItem) return;

      if(dataItem.Cmd){
        var $cmd = dataItem.Cmd;
        var $actionObj = this.$getActionObj();
        this.$cmd.toCmd($cmd,$actionObj)
        return;
      }

      if(dataItem.DetailUrl){
        var url = dataItem.DetailUrl;
        console.log("url",url);
        this.$path.to(url);
        return;
      }
      //this.onDetailClick2(dataItem,index);
      //this.$parent2.onDetailClick(dataItem, index);
    },

    async onPageLoad() {
      if (!this.isFirst) {
        this.isFirst = true;
        this.isLoading = false;
        return;
      }
      var pageIndex = this.Page.PageIndex + 1;
      var pageSize = this.Page.PageSize;
      await this.getIndexPaged(pageIndex, pageSize);
    },

    async getIndexPaged(pageIndex, pageSize) {
      //var url = "/mTplApi/Template/GetIndexPaged";

      this.$msg.showLoading("正在获取详细信息...");
      
      var postData = this.$getSubmitData();
      if(!postData){
        postData = {};
      }
      
      postData.PageIndex = pageIndex;
      postData.PageSize = pageSize;

      console.log(this.dataConfig,'this.dataConfig')
      postData.QueryValue = this.dataConfig.QueryValue;
  
      var url = this.dataConfig.GetPagedUrl;
      if(!url) {        
        this.$msg.alert("url不能为空");
        return false;        
      }

      var result = await this.$web.post(url,postData);

      this.$msg.hideLoading();
      this.isLoading = false;
      if (result.state == 1) {
        this.Page = result.data.Page;
        if (this.Page.PageIndex >= this.Page.PageCount) {
          this.isFinished = true;
        }

        if(result.data.Rows){
          this.dataConfig.DataList = this.dataConfig.DataList.concat(
            result.data.Rows
          );
        }
        
        return;
      }

      console.log("dataConfig.DataList", this.dataConfig.DataList);
    }
  }
};
